/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IIntegrationQueryVariables = Types.Exact<{
  integrationId: Types.Scalars['ID']['input'];
}>;

export type IIntegrationQuery = {
  __typename?: 'Query';
  integration:
    | {
        __typename?: 'CustomIntegration';
        id: string;
        accountName?: string | null;
        accountUrl?: string | null;
        provider: string;
        tenantId?: string | null;
        active: boolean;
        createdAt: any;
        updatedAt: any;
        policy: { __typename?: 'IntegrationPolicy'; update: boolean; createMember: boolean; read: boolean };
      }
    | {
        __typename?: 'OauthIntegration';
        id: string;
        accountName?: string | null;
        accountUrl?: string | null;
        provider: string;
        tenantId?: string | null;
        active: boolean;
        createdAt: any;
        updatedAt: any;
        policy: { __typename?: 'IntegrationPolicy'; update: boolean; createMember: boolean; read: boolean };
      }
    | {
        __typename?: 'ShareFileIntegration';
        id: string;
        accountName?: string | null;
        accountUrl?: string | null;
        provider: string;
        tenantId?: string | null;
        active: boolean;
        createdAt: any;
        updatedAt: any;
        policy: { __typename?: 'IntegrationPolicy'; update: boolean; createMember: boolean; read: boolean };
      };
};

export const IntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'integration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OauthIntegration' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'OauthIntegrationFragment' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomIntegration' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomIntegrationFragment' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShareFileIntegration' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShareFileIntegrationFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OauthIntegrationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OauthIntegration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomIntegrationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomIntegration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShareFileIntegrationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShareFileIntegration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IIntegrationQuery, IIntegrationQueryVariables>;
